import {
  GET_CARDMAPPING_CATALOG,
  GET_CARDMAPPING_CATALOG_SUCCESS,
  GET_CARDMAPPING_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getCardMappingCatalogRed = (
  state: any,
  actions: any
) => {
  switch (actions.type) {
    case GET_CARDMAPPING_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_CARDMAPPING_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    case GET_CARDMAPPING_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
